<template>
  <modal size="lg" @close="$emit('close')">
    <div class="w-full flex flex-wrap">
      <p class="text-center">Input the URL of the image you would like to insert.</p>
      <div class="w-full flex items-end mb-2 px-2">
        <nx-input
          :info="valid ? null : 'Images must be a secure link (https)'"
          type="url"
          v-model="url"
          label="Image URL"
          id="url"
          :focus="true"
          class="flex-1"
        />
        <nx-button
          class="ml-2 block"
          :disabled="!valid || loading"
          @click="$emit('success', url)"
        >{{ loading ? 'Loading..' : 'Insert from URL' }}</nx-button>
      </div>
      <p class="text-center">Or upload an image from your device.</p>
      <form class="w-full" @submit.prevent="submit">
        <nx-file-input
          :errors="form.errors"
          label="Image"
          id="file"
          accept="image/*"
          @input="(input) => file = input"
          class="inline-block"
        ></nx-file-input>

        <nx-button
          native-type="submit"
          v-if="file"
          type="secondary"
          :disabled="loading"
          class="inline-block ml-2"
        >{{ loading ? 'Loading..' : 'Upload Image' }}</nx-button>
      </form>
    </div>
  </modal>
</template>

<script>
import Form from "form-backend-validation"

export default {
  name: "RichTextImageModal",
  data() {
    return {
      form: new Form(),
      url: "",
      file: null,
      pattern: /https.*/i,
      loading: false
    }
  },
  computed: {
    valid() {
      if (this.url.length < 5) return true
      return this.pattern.test(this.url)
    }
  },
  methods: {
    submit() {
      this.form.errors.clear("file")
      this.$api.images
        .create(this.file)
        .then(({ data }) => {
          this.$emit("success", data.url)
        })
        .catch(data => {
          if (data.response && data.response.status === 422) {
            this.form.onFail(data)
          }
        })
    }
  }
}
</script>

